"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.button = void 0;
const helpers_1 = require("../../../lib/helpers");
const base_1 = require("../base");
exports.button = {
    backgroundColor: {
        primary: base_1.colors.accent,
        secondary: base_1.colors.formControl,
        danger: base_1.colors.red500,
    },
    color: {
        primary: (0, helpers_1.displayModeToken)({
            light: (0, helpers_1.themeToken)("onAccentColorLight"),
            dark: (0, helpers_1.themeToken)("onAccentColorDark"),
        }),
        secondary: base_1.colors.text.primary,
        danger: base_1.colors.white,
    },
    paddingHorizontal: {
        tiny: base_1.spacing.small,
        small: base_1.spacing.medium,
        medium: base_1.spacing.medium,
    },
    height: {
        tiny: 24,
        small: 36,
        medium: 42,
    },
};
